import { clearStorageKeepingThemes } from '@/helpers/theme';
import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    // The design System Configuration > Sign-in sets (version 1, 2 or 3).
    component: () => import("../views/account/auth-pages.vue"),
    props: { page: "login" },
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const token = localStorage.getItem('jwt');
        let user = null;
        try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch (e) { /* none */ }
        // The token revoked on the server too. fetch, not axios: axios's 401 handler
        // (App.vue) would refresh the token and store it again.
        if (token) {
          fetch(`${process.env.VUE_APP_AUTHDOMAIN}/api/logout`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
            keepalive: true,
          }).catch(() => { /* signed out here regardless */ });
        }
        // Everything but people's own themes (System Configuration > Appearance).
        clearStorageKeepingThemes();
        sessionStorage.clear();
        // Who signed out, and when, for the page.
        try { sessionStorage.setItem('signedOut', JSON.stringify({ name: user?.name || '', at: Date.now() })); } catch (e) { /* not shown */ }
        next();
      },
    },
    component: () => import("../views/account/auth-pages.vue"),
    props: { page: "logout" },
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: () => import("../views/account/register.vue"),
  //   meta: {
  //     title: "Register",
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "default" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/auth-pages.vue"),
    props: { page: "forgot" },
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password/:token",
    name: "Reset Password",
    // In the sign-in pages' design (System Configuration > Sign-in pages).
    component: () => import("../views/account/auth-pages.vue"),
    props: { page: "reset" },
    meta: {
      title: "Reset Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        // Continue to the login page
        next();
      },
    },
  },

  // Utility Pages
  {
    path: "/blank",
    name: "Blank",
    meta: {
      title: "Blank",
      authRequired: true
    },
    component: () =>
      import("../views/utility-pages/blank.vue"),
  },
  {
    path: "/error/no-permission",
    name: "ErrorNoPermission",
    meta: {
      title: "No Permission",
      authRequired: true
    },
    component: () =>
      import("../views/utility-pages/no-permission.vue"),
  },

  // Home: where users land after logging in (greeting, clock, quick access).
  {
    path: "/home",
    name: "Home",
    meta: { title: "Home", authRequired: true },
    component: () => import("../views/home/landing/index.vue"),
  },
  // The site root opens Home.
  {
    path: "/",
    redirect: { name: "Home" },
  },
  // Dashboard (the old landing page, formerly at "/")
  {
    path: "/dashboard",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    // component: () => import("../views/pages/home.vue"),
    component: () => import("../views/home/dashboard/index.vue"),
  },
  {
    path: "/dashboard/ar",
    name: "ARDashboard",
    meta: {
      title: "AR Dashboard",
      authRequired: true,
    },
    // component: () => import("../views/home/dashboard/ar-dashboard.vue")
    component: () => import("../views/home/ar-dashboard/index")
  },
  {
    path: "/dashboard/ap",
    name: "APDashboard",
    meta: {
      title: "AP Dashboard",
      authRequired: true,
    },
    component: () => import("../views/home/ap-dashboard/index")
  },
  {
    path: "/dashboard/ga",
    name: "GADashboard",
    meta: {
      title: "GA Dashboard",
      authRequired: true,
    },
    // component: () => import("../views/home/dashboard/ar-dashboard.vue")
    component: () => import("../views/home/ga-dashboard/index")
  },
  {
    path: "/dashboard/expenses",
    name: "dashboard-expenses",
    meta: {
      title: "Expenses Dashboard",
      authRequired: true,
    },
    // component: () => import("../views/pages/home.vue"),
    component: () => import("../views/home/dashboard/expenses-dashboard.vue"),
  },
  {
    path: "/dashboard/flow-chart",
    name: "DashboardFlowChart",
    meta: {
      title: "Flow Chart",
      authRequired: true,
    },
    component: () => import("../views/home/flow-chart/index.vue"),
  },
  {
    path: "/dashboard/flowchart",
    redirect: "/dashboard/flow-chart",
  },

  // Maintenance

  // Operating Unit
  {
    path: "/maintenance/ou/index",
    name: "OperatingUnit",
    meta: { title: "Operating Unit", authRequired: true },
    component: () => import("../views/maintenance/ou/index"),
  },

  // Account Groups
  {
    path: "/maintenance/account-groups/index",
    name: "AccountGroups",
    meta: { title: "Account Group", authRequired: true },
    component: () => import("../views/maintenance/account-groups/index"),
  },

  // Account Classifications
  {
    path: "/maintenance/account-classifications/index",
    name: "AccountClassifications",
    meta: { title: "Account Classifications", authRequired: true },
    component: () =>
      import("../views/maintenance/account-classifications/index"),
  },

  // Chart of Accounts
  {
    path: "/maintenance/chart-of-accounts/index",
    name: "ChartOfAccounts",
    meta: { title: "Chart of Account", authRequired: true },
    component: () => import("../views/maintenance/chart-of-accounts/index"),
  },
  {
    path: "/maintenance/chart-of-accounts/form_sub/:acct_code",
    name: "EditChartOfAccountSub",
    meta: { title: "Edit Chart of Account Sub", authRequired: true },
    component: () => import("../views/maintenance/chart-of-accounts/form_sub"),
  },

  // Cost Centers
  {
    path: "/maintenance/cost-centers/index",
    name: "CostCenters",
    meta: { title: "Cost Center", authRequired: true },
    component: () => import("../views/maintenance/cost-centers/index"),
  },

  // Clients
  {
    path: "/maintenance/clients/index",
    name: "Clients",
    meta: { title: "Clients", authRequired: true },
    component: () => import("../views/maintenance/clients/index"),
  },
  {
    path: "/maintenance/clients/form/:client_id",
    name: "AddOtherClientInfo",
    meta: { title: "Add Other Client Info", authRequired: true },
    component: () => import("../views/maintenance/clients/form"),
  },

  // Clients V2
  {
    path: "/maintenance/clients-v2",
    alias: ["/maintenance/clients-v2/index", "/maintenance/clients-v2/"],
    name: "ClientsV2",
    meta: { title: "Client Management V2", authRequired: true },
    component: () => import("../views/maintenance/clients-v2/index.vue"),
  },
  {
    path: "/maintenance/clients-v2/create",
    name: "CreateClientV2",
    meta: { title: "Create Client V2", authRequired: true },
    component: () => import("../views/maintenance/clients-v2/wizard-form.vue"),
  },
  {
    path: "/maintenance/clients-v2/edit/:client_id",
    name: "EditClientV2",
    meta: { title: "Edit Client V2", authRequired: true },
    component: () => import("../views/maintenance/clients-v2/wizard-form.vue"),
  },
  {
    path: "/maintenance/clients-v2/view/:client_id",
    name: "ViewClientV2",
    meta: { title: "View Client V2", authRequired: true },
    component: () => import("../views/maintenance/clients-v2/wizard-form.vue"),
  },
  {
    path: "/maintenance/clients-v2/form/:client_id",
    name: "ClientOtherInfoV2",
    meta: { title: "Client Other Info V2", authRequired: true },
    component: () => import("../views/maintenance/clients-v2/form.vue"),
  },

  // Customers Module
  {
    path: "/maintenance/customers",
    alias: ["/maintenance/customers/index", "/maintenance/customers/"],
    name: "CustomersIndex",
    meta: { title: "Customer Management", authRequired: true },
    component: () => import("../views/maintenance/customers/index.vue"),
  },
  {
    path: "/maintenance/customers/create",
    name: "CreateCustomer",
    meta: { title: "Create Customer", authRequired: true },
    component: () => import("../views/maintenance/customers/wizard-form.vue"),
  },
  {
    path: "/maintenance/customers/edit/:client_id",
    name: "EditCustomer",
    meta: { title: "Edit Customer", authRequired: true },
    component: () => import("../views/maintenance/customers/wizard-form.vue"),
  },
  {
    path: "/maintenance/customers/view/:client_id",
    name: "ViewCustomer",
    meta: { title: "View Customer", authRequired: true },
    component: () => import("../views/maintenance/customers/wizard-form.vue"),
  },

  // Suppliers Module
  {
    path: "/maintenance/suppliers",
    alias: ["/maintenance/suppliers/index", "/maintenance/suppliers/"],
    name: "SuppliersIndex",
    meta: { title: "Supplier Management", authRequired: true },
    component: () => import("../views/maintenance/suppliers/index.vue"),
  },
  {
    path: "/maintenance/suppliers/create",
    name: "CreateSupplier",
    meta: { title: "Create Supplier", authRequired: true },
    component: () => import("../views/maintenance/suppliers/wizard-form.vue"),
  },
  {
    path: "/maintenance/suppliers/edit/:client_id",
    name: "EditSupplier",
    meta: { title: "Edit Supplier", authRequired: true },
    component: () => import("../views/maintenance/suppliers/wizard-form.vue"),
  },
  {
    path: "/maintenance/suppliers/view/:client_id",
    name: "ViewSupplier",
    meta: { title: "View Supplier", authRequired: true },
    component: () => import("../views/maintenance/suppliers/wizard-form.vue"),
  },

  // Agents Module
  {
    path: "/maintenance/agents",
    alias: ["/maintenance/agents/index", "/maintenance/agents/"],
    name: "AgentsIndex",
    meta: { title: "Agent Management", authRequired: true },
    component: () => import("../views/maintenance/agents/index.vue"),
  },
  {
    path: "/maintenance/agents/create",
    name: "CreateAgent",
    meta: { title: "Create Agent", authRequired: true },
    component: () => import("../views/maintenance/agents/wizard-form.vue"),
  },
  {
    path: "/maintenance/agents/edit/:client_id",
    name: "EditAgent",
    meta: { title: "Edit Agent", authRequired: true },
    component: () => import("../views/maintenance/agents/wizard-form.vue"),
  },
  {
    path: "/maintenance/agents/view/:client_id",
    name: "ViewAgent",
    meta: { title: "View Agent", authRequired: true },
    component: () => import("../views/maintenance/agents/wizard-form.vue"),
  },


  // Departments
  {
    path: "/maintenance/departments/index",
    name: "Departments",
    meta: { title: "Departments", authRequired: true },
    component: () => import("../views/maintenance/departments/index"),
  },

  // Employees
  {
    path: "/maintenance/employees/index",
    name: "Employees",
    meta: { title: "Employees", authRequired: true },
    component: () => import("../views/maintenance/employees/index"),
  },

  // Sales Officer
  {
    path: "/maintenance/sales-officer/index",
    name: "SalesOfficer",
    meta: { title: "Sales Officer", authRequired: true },
    component: () => import("../views/maintenance/sales-officer/index"),
  },

  // Doc Types
  {
    path: "/maintenance/doc-types/index",
    name: "DocTypes",
    meta: { title: "Doc Types", authRequired: true },
    component: () => import("../views/maintenance/doc-types/index"),
  },

  // JV Trans Types
  {
    path: "/maintenance/jv-trans-types/index",
    name: "JVTransTypes",
    meta: { title: "JV Transaction Types", authRequired: true },
    component: () => import("../views/maintenance/jv-trans-types/index"),
  },

  // Fiscal Calendar
  {
    path: "/maintenance/fiscal-calendar/index",
    name: "FiscalCalendar",
    meta: { title: "Fiscal Calendar", authRequired: true },
    component: () => import("../views/maintenance/fiscal-calendar/index"),
  },

  // Convertion Rates
  {
    path: "/maintenance/convertion-rates",
    name: "ConvertionRates",
    meta: { title: "Convertion Rates", authRequired: true },
    component: () => import("../views/maintenance/convertion-rates/index"),
  },

  // Payment Terms
  {
    path: "/maintenance/payment-terms/index",
    name: "PaymentTerms",
    meta: { title: "Payment Terms", authRequired: true },
    component: () => import("../views/maintenance/payment-terms/index"),
  },

  // Industry List
  {
    path: "/maintenance/industries/index",
    name: "Industry",
    meta: { title: "Industry", authRequired: true },
    component: () => import("../views/maintenance/industries/index"),
  },

  // Bank List
  {
    path: "/maintenance/banks/index",
    name: "Bank",
    meta: { title: "Bank", authRequired: true },
    component: () => import("../views/maintenance/banks/index"),
  },

  // Bank Agents
  {
    path: "/maintenance/banks-agents",
    name: "BanksAgents",
    meta: { title: "Banks Agents", authRequired: true },
    component: () => import("../views/maintenance/banks-agents/index"),
  },

  // Tax Codes
  {
    path: "/maintenance/tax-codes/index",
    name: "TaxCode",
    meta: { title: "Tax Codes", authRequired: true },
    component: () => import("../views/maintenance/tax-codes/index"),
  },

  // Analysis Codes
  {
    path: "/maintenance/analysis-codes/index",
    name: "AnalysisCode",
    meta: { title: "Analysis Codes", authRequired: true },
    component: () => import("../views/maintenance/analysis-codes/index"),
  },

  // Transaction Types
  {
    path: "/maintenance/transaction-types/index",
    name: "TransactionType",
    meta: { title: "Transaction Types", authRequired: true },
    component: () => import("../views/maintenance/transaction-types/index"),
  },

  // Client Analysis Flag
  {
    path: "/maintenance/client-analysis/index",
    name: "ClientAnalysis",
    meta: { title: "Client Analysis Flag", authRequired: true },
    component: () => import("../views/maintenance/client-analysis/index"),
  },

  // Approver List
  {
    path: "/maintenance/approver-list/index",
    name: "ApproverList",
    meta: { title: "Approver List", authRequired: true },
    component: () => import("../views/maintenance/approver-list/index"),
  },

  // Vehicle List
  {
    path: "/maintenance/vehicles/index",
    name: "Vehicles",
    meta: { title: "Vehicles Codes", authRequired: true },
    component: () => import("../views/maintenance/vehicles/index"),
  },

  // Signatory Registration
  {
    path: "/maintenance/signatory/index",
    name: "RegisteredSignatories",
    meta: { title: "Registered Signatories", authRequired: true },
    component: () => import("../views/maintenance/signatory/index"),
  },

  // Asset Location
  {
    path: "/assets/maintenance/location-management",
    name: "AssetLocMgmt",
    meta: { title: "Asset Location Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-location"),
  },
  // Asset Class
  {
    path: "/assets/maintenance/class-management",
    name: "AssetClassMgmt",
    meta: { title: "Asset Class Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-class"),
  },
  // Asset Groups
  {
    path: "/items/maintenance/group-management",
    name: "AssetGrpMgmt",
    meta: { title: "Asset Group Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-group"),
  },
  // Asset Groups
  {
    path: "/items/maintenance/account-rule-definition",
    name: "AssetAcctRulDef",
    meta: { title: "Asset Acct Rule Definition", authRequired: true },
    component: () =>
      import("../views/assets/maintenance/account-rule-definition"),
  },
  // Asset Template
  {
    path: "/items/maintenance/template-management",
    name: "AssetTemplateMgmt",
    meta: { title: "Asset Template Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-template"),
  },
  // Asset Category Mgmt
  {
    path: "/items/maintenance/category-management",
    name: "AssetCategoryMgmt",
    meta: { title: "Asset Category Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-category"),
  },
  // Asset Type
  {
    path: "/items/maintenance/type-management",
    name: "AssetTypeMgmt",
    meta: { title: "Item Type Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-type"),
  },
  // Asset Registry
  {
    path: "/items/maintenance/registration-management",
    name: "AssetRegMgmt",
    meta: { title: "Asset Registration Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-registry"),
  },
  // Asset Registry Verification
  {
    path: "/items/maintenance/registration-verification",
    name: "AssetRegVerification",
    meta: { title: "Asset Registration Verification", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-registry-verification"),
  },
  // Asset Budget
  {
    path: "/assets/maintenance/budget-management",
    name: "AssetBudgetMgmt",
    meta: { title: "Asset Budget Mgmt", authRequired: true },
    component: () => import("../views/assets/maintenance/asset-budget"),
  },
  // Asset Budget Report
  {
    path: "/assets/reports/asset-budget-report",
    name: "AssetBudgetReport",
    meta: { title: "Asset Budget Report", authRequired: true },
    component: () => import("../views/assets/reports/asset-budget-report"),
  },
  // Asset Proposal
  {
    path: "/assets/proposal-management",
    name: "AssetProposalMgmt",
    meta: { title: "Asset Proposal Mgmt", authRequired: true },
    component: () =>
      import("../views/assets/proposal-management/asset-proposal"),
  },
  // // Asset Issuance
  // {
  //   path: "/items/issuance-management",
  //   name: "IssuanceList",
  //   meta: { title: "Asset Issuance Management", authRequired: true },
  //   component: () =>
  //     import("../views/assets/issuance/index"),
  // },
  // {
  //   path: "/items/issuance-form",
  //   name: "IssuanceForm",
  //   meta: { title: "Asset Issuance Management", authRequired: true },
  //   component: () =>
  //     import("../views/assets/issuance/form"),
  // },
  // PR Entry Form
  {
    path: "/purchasing-mgmt/purchase-request/entry",
    name: "PREntry",
    meta: { title: "PR Entry", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-request/pr-form"),
  },
  // PR Edit Form
  {
    path: "/purchasing-mgmt/purchase-request/:requestID/edit",
    name: "PREditForm",
    meta: { title: "PR Edit Form", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-request/pr-form"),
  },
  // PR Revision Form
  {
    path: "/purchasing-mgmt/purchase-request/:requestID/:validatorID/revise",
    name: "PRReviseForm",
    meta: { title: "PR Revision Form", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-request/pr-modification"),
  },
  // PR Approval Mgmt
  {
    path: "/purchasing-mgmt/pr-approval-mgmt",
    name: "PRsToApprove",
    meta: { title: "PR Approval Mgmt", authRequired: true },
    component: () =>
      import(
        "../views/purchasing-management/purchase-request/pr-approval-mgmt"
      ),
  },
  // PR Approval - Internal
  {
    path: "/purchasing-mgmt/purchase-request/approval/:requestID",
    name: "PurchaseRequestApproval",
    component: () =>
      import(
        "../views/purchasing-management/purchase-request/pr-approval-form"
      ),
    meta: { title: "PR Approval", authRequired: true },
  },
  // PR Approval - External
  {
    path: "/purchasing-mgmt/purchase-request/approval-ext/:requestID/:approverID/:prToken",
    name: "PurchaseRequestApprovalExt",
    component: () =>
      import("../views/purchasing-management/purchase-request/pr-approval-ext"),
    meta: {
      title: "PR Approval Mail",
      authRequired: false,
    },
  },
  // PR Report
  {
    path: "/purchasing-mgmt/report/pr-report/:requestID?",
    name: "PRReport",
    component: () =>
      import("../views/purchasing-management/purchase-request/pr-report"),
    meta: { title: "PR report", authRequired: true },
  },
  // PR Acknowledgement
  {
    path: "/purchasing-mgmt/pr-acknowledgement/:requestID?",
    name: "PRAcknowledgement",
    meta: { title: "PR Acknowledgement", authRequired: true },
    component: () =>
      import(
        "../views/purchasing-management/purchase-request/pr-acknowledgement"
      ),
  },
  // PR Acknowledgement Ext
  {
    path: "/purchasing-mgmt/purchase-acknowledgement/ext/:requestID/:acknowledgerID/:prTokenAck",
    name: "PurchaseRequestAcknowledgementExt",
    component: () =>
      import(
        "../views/purchasing-management/purchase-request/pr-acknowledgement-ext"
      ),
    meta: { title: "PR Acknowledgement Mail", authRequired: false },
  },
  // PR Validation
  {
    path: "/purchasing-mgmt/pr-validation/:requestID?",
    name: "PRValidation",
    meta: { title: "PR Validation", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-request/pr-validation"),
  },
  // PR Request Budget Adjustment
  {
    path: "/purchasing-mgmt/pr-budget-adjustment/:requestID?",
    name: "PRBudgetAdj",
    meta: { title: "PR Budget Adjustment", authRequired: true },
    component: () =>
      import(
        "../views/purchasing-management/purchase-request/pr-budget-adjustment"
      ),
  },
  // PR Request Budget Approval
  {
    path: "/purchasing-mgmt/pr-budget-approval",
    name: "PRBudgetApproval",
    meta: { title: "PR Budget Approval", authRequired: true },
    component: () =>
      import(
        "../views/purchasing-management/purchase-request/pr-budget-approval"
      ),
  },
  // Purchase Order Form
  {
    path: "/purchasing-mgmt/po-entry-form/:poID?",
    name: "POForm",
    meta: { title: "PO Form", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-order/po-form"),
  },
  // Purchase Order Report
  {
    path: "/purchasing-mgmt/purchase-order/report",
    name: "PurchaseOrderReport",
    meta: { title: "PO Report", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-order/po-report"),
  },
  // Purchase Order Validation - Internal
  {
    path: "/purchasing-mgmt/purchase-order/validation/:poID?",
    name: "PurchaseOrderValidation",
    meta: { title: "PO Validation", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-order/po-validation"),
  },
  // Purchase Order Validation - External
  {
    path: "/purchasing-mgmt/purchase-order/validation-ext/:poID/:validatorID/:poToken",
    name: "PurchaseOrderValidationExt",
    component: () =>
      import("../views/purchasing-management/purchase-order/po-validation-ext"),
    meta: { title: "PO Validation Mail", authRequired: false },
  },
  // Purchase Order Approval - Internal
  {
    path: "/purchasing-mgmt/purchase-order/approval/:poID?",
    name: "PurchaseOrderApproval",
    meta: { title: "PO Approval", authRequired: true },
    component: () =>
      import("../views/purchasing-management/purchase-order/po-approval"),
  },
  // Purchase Order Approval - External
  {
    path: "/purchasing-mgmt/purchase-order/approval-ext/:poID/:approverID/:poToken",
    name: "PurchaseOrderApprovalExt",
    component: () =>
      import("../views/purchasing-management/purchase-order/po-approval-ext"),
    meta: { title: "PO Approval Mail", authRequired: false },
  },
  {
    path: "/purchasing-mgmt/goods-receipt/list",
    name: "GR List",
    meta: { title: "GR Report", authRequired: true },
    component: () => import("../views/purchasing-management/goods-receipt/gr-list"),
  },
  {
    path: "/purchasing-mgmt/goods-receipt/form/:grID?",
    name: "GR Form",
    meta: { title: "GR Form", authRequired: true },
    // component: () => import("../views/goods-receipt/_id"),
    component: () => import("../views/purchasing-management/goods-receipt/gr-form"),
  },
  {
    path: "/purchasing-mgmt/gr-without-po/form/:grID?",
    name: "GR Form Without PO",
    meta: { title: "GR Form Without PO", authRequired: true },
    component: () => import("../views/purchasing-management/goods-receipt/gr-without-po"),
  },
  // Asset Capitalization
  {
    path: "/assets/capitalization/index",
    name: "ACapitalization",
    meta: { title: "CAPITAL WIP", authRequired: true },
    component: () => import("../views/assets/capitalization/index"),
  },
  // Asset Capitalization
  {
    path: "/assets/capitalization/form/:acap_reference?",
    name: "CapitalizationForm",
    meta: { title: "CAPITAL WIP", authRequired: true },
    component: () => import("../views/assets/capitalization/form"),
  },
  // Upload Asset Balances
  {
    path: "/assets/upload/asset-balances",
    name: "UploadAssetBalances",
    meta: { title: "UPLOAD ASSET BALANCES", authRequired: true },
    component: () => import("../views/assets/upload/asset-balances/index"),
  },
  {
    path: "/assets/upload/asset-balances/form/:mig_reference?",
    name: "UploadAssetBalancesForm",
    meta: { title: "UPLOAD ASSET BALANCES FORM", authRequired: true },
    component: () => import("../views/assets/upload/asset-balances/form"),
  },
  // Asset Depreciation Category
  {
    path: "/assets/depreciation/depreciation-category",
    name: "DepreciationCategoryMgmt",
    meta: { title: "Depreciation Category MGMT", authRequired: true },
    component: () =>
      import("../views/assets/depreciation/depreciation-category"),
  },
  // // Asset Depreciation Setup
  // {
  //   path: "/items/depreciation/depreciation-setup",
  //   name: "AssetDepreciation",
  //   meta: { title: "Asset Depreciation", authRequired: true },
  //   component: () => import("../views/assets/depreciation/asset-depreciation"),
  // },
  // Asset Depreciation Report
  {
    path: "/assets/depreciation/depreciation-report",
    name: "DepreciationReport",
    meta: { title: "Depreciation Report", authRequired: true },
    component: () => import("../views/assets/depreciation/depreciation-report"),
  },
  // Lapsing Schedule Report
  {
    path: "/assets/depreciation/lapsing-sched-report",
    name: "LapsingSchedReport",
    meta: { title: "Lapsing Schedule Report", authRequired: true },
    component: () =>
      import("../views/assets/depreciation/lapsing-sched-report"),
  },
  // Asset List Report
  {
    path: "/assets/reports/asset-list",
    name: "AssetListReport",
    meta: { title: "Asset List Report", authRequired: true },
    component: () =>
      import("../views/assets/reports/asset-list"),
  },
  // Asset Deployment Report
  {
    path: "/assets/reports/deployment",
    name: "AssetDeploymentReport",
    meta: { title: "Asset Deployment Report", authRequired: true },
    component: () =>
      import("../views/assets/reports/deployment"),
  },
  // Asset Retired Report
  {
    path: "/assets/reports/retired",
    name: "AssetRetiredReport",
    meta: { title: "Asset Retired Report", authRequired: true },
    component: () =>
      import("../views/assets/reports/retired"),
  },
  // Asset Depreciation
  {
    path: "/assets/depreciation/index",
    name: "DepreciationList",
    meta: { title: "Asset Depreciation", authRequired: true },
    component: () => import("../views/assets/depreciation/index"),
  },
  {
    path: "/assets/depreciation/form/:adepRef?",
    name: "DepreciationForm",
    meta: { title: "Asset Depreciation", authRequired: true },
    component: () => import("../views/assets/depreciation/form"),
  },
  // Asset Retirement
  {
    path: "/assets/retirement/index",
    name: "AssetRetirementList",
    meta: { title: "Asset Retirement", authRequired: true },
    component: () => import("../views/assets/retirement/index"),
  },
  {
    path: "/assets/retirement/form/:aretRef?",
    name: "AssetRetirementForm",
    meta: { title: "Asset Retirement", authRequired: true },
    component: () => import("../views/assets/retirement/form"),
  },
  // Asset Inventory Report
  {
    path: "/assets/inventory/inventory-report",
    name: "InventoryReport",
    meta: { title: "Inventory Report", authRequired: true },
    component: () => import("../views/assets/inventory/inventory-report"),
  },
  // OR Series
  {
    path: "/maintenance/or-series/index",
    name: "ORSeries",
    meta: { title: "OR Series", authRequired: true },
    component: () => import("../views/maintenance/or-series/index"),
  },
  // GA
  {
    path: "/transactions/ga/index",
    name: "GeneralAccounting",
    meta: { title: "General Accounting", authRequired: true },
    component: () => import("../views/transactions/ga/index"),
  },
  {
    path: "/transactions/general-accounting",
    name: "GeneralAccountingV3",
    meta: { title: "General Accounting > Transaction Details", authRequired: true },
    component: () => import("../views/transactions/ga/details"),
  },
  {
    path: "/doc-status",
    name: "DocStatus",
    meta: { title: "Doc Status", authRequired: true },
    component: () => import("../views/doc-status/index"),
  },
  {
    path: "/document-tracing",
    name: "DocumentTracing",
    meta: { title: "Document Tracing", authRequired: true },
    component: () => import("../views/document-tracing/index"),
  },
  {
    path: "/document-ref-tracing",
    name: "DocumentRefTracing",
    meta: { title: "Document Ref Tracing", authRequired: true },
    component: () => import("../views/document-ref-tracing/index"),
  },
  {
    path: "/transactions/recurring-voucher",
    name: "RecurringVoucher",
    meta: { title: "Recurring Voucher", authRequired: true },
    component: () => import("../views/transactions/recurring-voucher/index"),
  },
  // OR / AR
  {
    path: "/transactions/or/index",
    name: "OR-AR",
    query: { trans_type: "or" },
    meta: { title: "OR & AR List", authRequired: true },
    component: () => import("../views/transactions/or/index"),
  },
  {
    path: "/transactions/or/form/:orno?",
    name: "CreateOR-AR",
    query: { trans_type: "or" },
    meta: { title: "Create OR / AR", authRequired: true },
    component: () => import("../views/transactions/or/form"),
  },

  // AR
  {
    path: "/transactions/ar/index",
    name: "AcknowledgementReceipt",
    query: { trans_type: "ar" },
    meta: { title: "Acknowledgement Receipt", authRequired: true },
    component: () => import("../views/transactions/or/index"),
  },
  {
    path: "/transactions/ar/form/:orno?",
    name: "CreateAcknowledgementReceipt",
    query: { trans_type: "ar" },
    meta: { title: "Create Acknowledgement Receipt", authRequired: true },
    component: () => import("../views/transactions/or/form"),
  },

  // Official Receipt Sundry
  // OR / AR Sundry
  {
    path: "/transactions/or-sundry/index",
    name: "OR-ARSundry",
    query: { trans_type: "or_sundry" },
    meta: { title: "OR & AR Sundry List", authRequired: true },
    component: () => import("../views/transactions/or/index"),
  },
  {
    path: "/transactions/or-sundry/form/:orno?",
    name: "CreateOR-ARSundry",
    query: { trans_type: "or_sundry" },
    meta: { title: "Create OR / AR Sundry", authRequired: true },
    component: () => import("../views/transactions/or/form"),
  },

  {
    path: "/transactions/sales-invoice/form",
    name: "Sales Invoice",
    meta: { title: "Sales Invoice", authRequired: true },
    component: () => import("../views/transactions/sales-invoice/form"),
  },

  {
    path: "/ar-management/or",
    name: "OfficialReceipt",
    query: { trans_type: "or" },
    meta: { title: "Official Receipt", authRequired: true },
    component: () => import("../views/ar-management/or/index"),
  },
  {
    path: "/ar-management/form",
    name: "CreateOfficialReceipt",
    meta: { title: "Create Official Receipt", authRequired: true },
    component: () => import("../views/ar-management/or/form"),
  },
  {
    path: "/ar-management/form/:control_number",
    name: "EditOfficialReceipt",
    meta: { title: "Edit Official Receipt", authRequired: true },
    component: () => import("../views/ar-management/or/form"),
  },

  {
    path: "/ar-management/or-sundry",
    name: "OfficialReceiptSundry",
    query: { trans_type: "or_sundry" },
    meta: { title: "Official Receipt Sundry", authRequired: true },
    component: () => import("../views/ar-management/or/index"),
  },
  {
    path: "/ar-management/form",
    name: "CreateOfficialReceiptSundry",
    query: { trans_type: "or_sundry" },
    meta: { title: "Create Official Receipt Sundry", authRequired: true },
    component: () => import("../views/ar-management/or/form"),
  },
  {
    path: "/ar-management/form/:control_number",
    name: "EditOfficialReceiptSundry",
    query: { trans_type: "or_sundry" },
    meta: { title: "Edit Official Receipt Sundry", authRequired: true },
    component: () => import("../views/ar-management/or/form"),
  },

  {
    path: "/transactions/offsettings/form",
    name: "Offsettings",
    meta: { title: "Offsettings", authRequired: true },
    component: () => import("../views/transactions/offsettings/form"),
  },

  {
    path: "/transactions/offsettings/index",
    name: "OffsettingsList",
    meta: { title: "Offsettings", authRequired: true },
    component: () => import("../views/transactions/offsettings/index"),
  },

  {
    path: "/transactions/offsettings/form/:offsetting_no",
    name: "EditOffsettings",
    meta: { title: "Edit Offsetting", authRequired: true },
    component: () => import("../views/transactions/offsettings/form"),
  },

  // Overpayment
  {
    path: "/transactions/overpayment-adjustment/form",
    name: "CreateOverpaymentAdjustment",
    meta: { title: "Create Overpayment Adjustment", authRequired: true },
    component: () =>
      import("../views/transactions/overpayment-adjustment/form"),
  },

  // Customer Balance Adjustment
  {
    path: "/transactions/cba/index",
    name: "CustomerBalanceAdjustment",
    meta: { title: "Customer Balance Adjustment", authRequired: true },
    component: () => import("../views/transactions/cba/index"),
  },
  {
    path: "/transactions/cba/form",
    name: "CreateCustomerBalanceAdjustment",
    meta: { title: "Create Customer Balance Adjustment", authRequired: true },
    component: () => import("../views/transactions/cba/form"),
  },
  {
    path: "/transactions/cba/form/:cba_no",
    name: "EditCustomerBalanceAdjustment",
    meta: { title: "Edit Customer Balance Adjustment", authRequired: true },
    component: () => import("../views/transactions/cba/form"),
  },

  // Menus
  {
    path: "/settings/menus",
    name: "Menus",
    meta: { title: "Menu", authRequired: true },
    component: () => import("../views/maintenance/menus/index"),
  },
  {
    path: "/settings/menus/form",
    name: "AddMenu",
    meta: { title: "Add Menu", authRequired: true },
    component: () => import("../views/maintenance/menus/form"),
  },
  {
    path: "/settings/menus/form/:id",
    name: "EditMenu",
    meta: { title: "Edit Menu", authRequired: true },
    component: () => import("../views/maintenance/menus/form"),
  },

  // Users
  {
    path: "/settings/users",
    name: "Users",
    meta: { title: "User", authRequired: true },
    component: () => import("../views/user-management/users/index"),
  },
  {
    path: "/settings/users/:id",
    name: "UserProfile",
    meta: { title: "User Profile", authRequired: true },
    component: () => import("../views/user-management/users/profile"),
  },
  {
    path: "/settings/users/form",
    name: "AddUser",
    meta: { title: "Add User", authRequired: true },
    component: () => import("../views/user-management/users/form"),
  },
  {
    path: "/settings/users/form/:id",
    name: "EditUser",
    meta: { title: "Edit User", authRequired: true },
    component: () => import("../views/user-management/users/form"),
  },

  {
    path: "/user/profile",
    name: "UserProfileView",
    meta: { title: "User", authRequired: true },
    component: () => import("../views/user-management/users/user-profile"),
  },

  // Roles
  {
    path: "/settings/roles",
    name: "Roles",
    meta: { title: "Role", authRequired: true },
    component: () => import("../views/user-management/roles/index"),
  },
  {
    path: "/settings/roles/:id",
    name: "ViewRole",
    meta: { title: "View Role", authRequired: true },
    component: () => import("../views/user-management/roles/info"),
  },
  {
    path: "/settings/roles/form",
    name: "AddRole",
    meta: { title: "Add Role", authRequired: true },
    component: () => import("../views/user-management/roles/form"),
  },
  {
    path: "/settings/roles/form/:id",
    name: "EditRole",
    meta: { title: "Edit Role", authRequired: true },
    component: () => import("../views/user-management/roles/form"),
  },
  // Users API
  {
    path: "/settings/api",
    name: "API",
    meta: { title: "API", authRequired: true },
    component: () => import("../views/user-management/api/index"),
  },
  {
    path: "/settings/api/form",
    name: "AddAPI",
    meta: { title: "Add API", authRequired: true },
    component: () => import("../views/user-management/api/form"),
  },
  // System Configuration: sign-in, maintenance, announcements
  {
    path: "/settings/system-configuration",
    name: "SystemConfiguration",
    meta: { title: "System Configuration", authRequired: true },
    component: () => import("../views/user-management/system-configuration/index"),
  },
  // Audit Trail: every change made in the transaction modules
  {
    path: "/settings/audit-trail",
    name: "AuditTrail",
    meta: { title: "Audit Trail", authRequired: true },
    component: () => import("../views/user-management/audit-trail/index"),
  },
  // Permissions
  {
    path: "/settings/permissions",
    name: "Permissions",
    meta: { title: "Permission", authRequired: true },
    component: () => import("../views/user-management/permissions/index"),
  },
  {
    path: "/settings/permissions/form",
    name: "AddPermission",
    meta: { title: "Add Permission", authRequired: true },
    component: () => import("../views/user-management/permissions/form"),
  },
  {
    path: "/settings/permissions/form/:id",
    name: "EditPermission",
    meta: { title: "Edit Permission", authRequired: true },
    component: () => import("../views/user-management/permissions/form"),
  },
  // Modules
  {
    path: "/settings/modules",
    name: "Modules",
    meta: { title: "Modules", authRequired: true },
    component: () => import("../views/user-management/modules/index"),
  },
  // Data Upload
  {
    path: "/system-settings/data-upload",
    name: "DataUpload",
    meta: { title: "Data Upload", authRequired: true },
    component: () => import("../views/system-settings/index"),
  },
  {
    path: "/transactions/journal-entries",
    name: "JournalEntry",
    meta: { title: "Journal Entry", authRequired: true },
    component: () => import("../views/transactions/journal-entries/index"),
  },
  {
    path: "/transactions/journal-entries/form",
    name: "AddJournalEntry",
    meta: { title: "Add Journal Entry", authRequired: true },
    component: () => import("../views/transactions/journal-entries/form"),
  },
  {
    path: "/transactions/journal-entries/form/:id",
    name: "EditJournalEntry",
    meta: { title: "Edit Journal Entry", authRequired: true },
    component: () => import("../views/transactions/journal-entries/form"),
  },
  {
    path: "/transactions/journal-entries/voucher/:id",
    name: "ViewJournalVoucher",
    meta: { title: "View Journal Voucher", authRequired: true },
    component: () =>
      import("../views/transactions/journal-entries/view-voucher"),
  },
  {
    path: "/transactions/general-ledger",
    name: "GeneralLedger",
    meta: { title: "General Ledger", authRequired: true },
    component: () => import("../views/transactions/gl/index"),
  },
  {
    path: "/transactions/active-transactions",
    name: "ActiveTransactions",
    meta: { title: "Active Transactions", authRequired: true },
    component: () => import("../views/transactions/active-transactions/index"),
  },
  {
    path: "/reports/trial-balance/index",
    name: "TrialBalanceReport",
    meta: { title: "Trial Balance Report", authRequired: true },
    component: () => import("../views/reports/trial-balance/index"),
  },
  {
    path: "/reports/financial-reports",
    name: "FinancialReports",
    meta: { title: "Financial Reports", authRequired: true },
    component: () => import("../views/reports/financial-reports/index.vue"),
  },
  {
    path: "/reports/balance-sheet",
    name: "BalanceSheet",
    meta: { title: "Balance Sheet", authRequired: true },
    component: () => import("../views/reports/balance-sheet/index.vue"),
  },
  {
    path: "/reports/general-ledger",
    name: "GeneralLedgerReport",
    meta: { title: "General Ledger", authRequired: true },
    component: () => import("../views/reports/general-ledger/index.vue"),
  },
  {
    path: "/reports/income-statement/index",
    name: "IncomeStatementReport",
    meta: { title: "Income Statement Report", authRequired: true },
    component: () => import("../views/reports/income-statement/index"),
  },
  // Financial Graph
  {
    path: "/reports/financial-graph/index",
    name: "FinancialGraph",
    meta: { title: "Financial Graph", authRequired: true },
    component: () => import("../views/reports/financial-graph/index"),
  },
  {
    path: "/reports/profit-and-loss",
    name: "ProfitAndLossReport",
    meta: { title: "Profit and Loss Report", authRequired: true },
    component: () => import("../views/reports/profit-and-loss/index"),
  },
  {
    path: "/reports/account-receivable/soa/index",
    name: "AcctRcvblSOA",
    meta: { title: "AR - SOA", authRequired: true },
    component: () => import("../views/reports/account-receivable/soa/index"),
  },
  {
    path: "/reports/account-receivable/soa/soa-by-rcv-date",
    name: "AR - Receivable Date",
    meta: { title: "AR - SOA", authRequired: true },
    component: () => import("../views/reports/account-receivable/soa/soa-by-rcv-date"),
  },
  {
    path: "/reports/account-receivable/soa/inquiry",
    name: "AcctRcvblSOAInquiry",
    meta: { title: "SOA Inquiry", authRequired: true },
    component: () => import("../views/reports/account-receivable/soa/inquiry"),
  },

  {
    path: "/transactions/billing/inquiry",
    name: "BillingInquiry",
    meta: { title: "Billing Inquiry", authRequired: true },
    component: () => import("../views/reports/billing/inquiry"),
  },
  {
    path: "/reports/account-receivable/soa/with-usd",
    name: "AcctRcvblSOAUSD",
    meta: { title: "AR - SOA", authRequired: true },
    component: () => import("../views/reports/account-receivable/soa/with-usd"),
  },
  {
    path: "/reports/account-receivable/soa/with-php-and-usd",
    name: "AcctRcvblSOAUSDANDPHP",
    meta: { title: "AR - SOA", authRequired: true },
    component: () =>
      import("../views/reports/account-receivable/soa/with-php-and-usd"),
  },
  {
    path: "/reports/account-receivable/soa/aging",
    name: "AcctRcvblSOAAging",
    meta: { title: "AR - SOA", authRequired: true },
    component: () => import("../views/reports/account-receivable/soa/aging"),
  },
  {
    path: "/reports/account-receivable/soa/with-running-balance",
    name: "AcctRcvblSOAFormat2",
    meta: { title: "AR - SOA", authRequired: true },
    component: () =>
      import("../views/reports/account-receivable/soa/with-running-balance"),
  },
  {
    path: "/reports/account-receivable/soa/with-charges",
    name: "AcctRcvblSOAFormat3",
    meta: { title: "AR - SOA", authRequired: true },
    component: () =>
      import("../views/reports/account-receivable/soa/with-charges"),
  },
  {
    path: "/reports/fs-reports",
    name: "FSReports",
    meta: { title: "FS Reports", authRequired: true },
    component: () => import("../views/reports/fs-reports/index"),
  },

  {
    path: "/reports/inventory-assets",
    name: "InventoryAssets",
    meta: { title: "Inventory Assets Reports", authRequired: true },
    component: () => import("../views/reports/inventory-assets/index"),
  },
  {
    path: "/reports/report-labels",
    name: "ReportLabels",
    meta: { title: "Report Label", authRequired: true },
    component: () => import("../views/reports/report-labels/index"),
  },
  {
    path: "/reports/report-templates",
    name: "ReportTemplates",
    meta: { title: "Report Template", authRequired: true },
    component: () => import("../views/reports/report-templates/index"),
  },
  {
    path: "/reports/report-templates/form",
    name: "AddReportTemplate",
    meta: { title: "Add Report Template", authRequired: true },
    component: () => import("../views/reports/report-templates/form"),
  },
  {
    path: "/reports/report-templates/form/:id",
    name: "EditReportTemplate",
    meta: { title: "Edit Report Template", authRequired: true },
    component: () => import("../views/reports/report-templates/form"),
  },
  {
    path: "/reports/report-generator",
    name: "ReportGenerator",
    meta: { title: "Report Generator", authRequired: true },
    component: () => import("../views/reports/report-generator/index"),
  },
  {
    path: "/transactions/customer-balance-transfer",
    name: "CustomerBalanceTransfer",
    meta: { title: "Customer Balance Transfer", authRequired: true },
    component: () => import("../views/balance-transfer/customer-balance/index"),
  },
  {
    path: "/transactions/customer-balance-transfer/form",
    name: "CreateCustomerBalanceTransfer",
    meta: { title: "Create Customer Balance Transfer", authRequired: true },
    component: () => import("../views/balance-transfer/customer-balance/form"),
  },
  {
    path: "/transactions/customer-balance-transfer/form/:trans_ref",
    name: "EditCustomerBalanceTransfer",
    meta: { title: "Edit Customer Balance Transfer", authRequired: true },
    component: () => import("../views/balance-transfer/customer-balance/form"),
  },


  // Supplier Balance Adjustment
  {
    path: "/transactions/supplier-balance-adjustment/index",
    name: "SupplierBalanceAdjustment",
    meta: { title: "Supplier Balance Adjustment", authRequired: true },
    component: () => import("../views/transactions/supplier-balance-adjustment/index"),
  },
  {
    path: "/transactions/supplier-balance-adjustment/form",
    name: "CreateSupplierBalanceAdjustment",
    meta: { title: "Create Supplier Balance Adjustment", authRequired: true },
    component: () => import("../views/transactions/supplier-balance-adjustment/form"),
  },
  {
    path: "/transactions/supplier-balance-adjustment/form/:sba_no",
    name: "EditSupplierBalanceAdjustment",
    meta: { title: "Edit Supplier Balance Adjustment", authRequired: true },
    component: () => import("../views/transactions/supplier-balance-adjustment/form"),
  },


  //Data Checker
  {
    path: "/data-checker/report/index",
    name: "DataCheckerGL",
    meta: { title: "Data Checker - GL", authRequired: true },
    component: () => import("../views/data-checker/report/index"),
  },
  {
    path: "/data-checker/ga-gl-comparison",
    name: "DataCheckerGAGL",
    meta: { title: "Data Checker - GA and GL Comparison", authRequired: true },
    component: () => import("../views/data-checker/report/ga-gl-comparison"),
  },
  {
    path: "/data-checker/reversal",
    name: "DataCheckerReversal",
    meta: { title: "Data Checker - Reversal", authRequired: true },
    component: () => import("../views/data-checker/report/reversal"),
  },
  {
    path: "/data-checker/source-serial-comparison",
    name: "DataCheckerSourceSerial",
    meta: { title: "Data Checker - Source and Serial Comparison", authRequired: true },
    component: () => import("../views/data-checker/report/source-serial-comparison"),
  },
  {
    path: "/foreign-transactions/payables-receivables",
    name: "ForeignPayablesReceivables",
    meta: { title: "Payables & Receivables", authRequired: true },
    component: () =>
      import("../views/reports/foreign-payables-receivables/index.vue"),
  },
  {
    path: "/maintenance/client-groups",
    name: "ClientGroups",
    meta: { title: "Client Groups", authRequired: true },
    component: () => import("../views/maintenance/client-groups/index.vue"),
  },
  {
    path: "/foreign-transactions/summary",
    name: "ForeignSummary",
    meta: { title: "Foreign Summary", authRequired: true },
    component: () => import("../views/reports/foreign-summary/index.vue"),
  },
  {
    path: "/foreign-transactions/supplier-payment",
    name: "SupplierPayment",
    meta: { title: "Supplier Payment", authRequired: true },
    component: () => import("../views/foreign-transactions/supplier-payment/index.vue"),
  },
  {
    path: "/foreign-transactions/supplier-payment/form",
    name: "CreateSupplierPayment",
    meta: { title: "New Supplier Payment", authRequired: true },
    component: () => import("../views/foreign-transactions/supplier-payment/form.vue"),
  },
  {
    path: "/foreign-transactions/supplier-payment/form/:voucher_no",
    name: "EditSupplierPayment",
    meta: { title: "Supplier Payment", authRequired: true },
    component: () => import("../views/foreign-transactions/supplier-payment/form.vue"),
  },
  {
    path: "/foreign-transactions/telegraphic",
    name: "Telegraphic",
    meta: { title: "Telegraphic", authRequired: true },
    component: () => import("../views/foreign-transactions/telegraphic/index.vue"),
  },
  // AP Trade from open ap_schedule items (Expense Invoice > Trade takes AP batches).
  {
    path: "/foreign-transactions/ap-trade",
    name: "ForeignAPTrade",
    meta: { title: "AP Trade", authRequired: true },
    component: () => import("../views/foreign-transactions/ap-trade/index.vue"),
  },
  {
    path: "/foreign-transactions/ap-trade/form",
    name: "AddForeignAPTrade",
    meta: { title: "Add AP Trade", authRequired: true },
    component: () => import("../views/foreign-transactions/ap-trade/form.vue"),
  },
  {
    path: "/foreign-transactions/ap-trade/form/:id",
    name: "EditForeignAPTrade",
    meta: { title: "Edit AP Trade", authRequired: true },
    component: () => import("../views/foreign-transactions/ap-trade/form.vue"),
  },
  {
    path: "/foreign-transactions/ap-trade/view",
    name: "ViewForeignAPTrade",
    meta: { title: "View AP Trade", authRequired: true },
    component: () => import("../views/foreign-transactions/ap-trade/view.vue"),
  },
  {
    path: "/data-checker/account-register",
    name: "DataCheckerAccountRegister",
    meta: { title: "Data Checker - Account Registry", authRequired: true },
    component: () => import("../views/data-checker/report/account-register"),
  },
  {
    path: "/data-checker/serial-registry",
    name: "SerialRegistry",
    meta: { title: "Data Checker - Serial Registry", authRequired: true },
    component: () => import("../views/data-checker/report/serial-registry"),
  },
  {
    path: "/data-checker/billing-ga-comparison",
    name: "DataCheckerBillingGA",
    meta: { title: "Data Checker - Billing and GA Comparison", authRequired: true },
    component: () => import("../views/data-checker/report/billing-ga-comparison"),
  },
  {
    path: "/data-checker/account-daily-movement-ga",
    name: "DataCheckerAccountDailyMovementGA",
    meta: { title: "Data Checker - Account Daily Movement (GA)", authRequired: true },
    component: () => import("../views/data-checker/report/account-daily-movement-ga"),
  },
  {
    path: "/data-checker/account-monthly-movement-ga",
    name: "DataCheckerAccountMonthlyMovementGA",
    meta: { title: "Data Checker - Account Montly Movement (GA)", authRequired: true },
    component: () => import("../views/data-checker/report/account-monthly-movement-ga"),
  },
  {
    path: "/data-checker/account-gl-movement",
    name: "DataCheckerAccountGLMovement",
    meta: { title: "Data Checker - Account GL Movement", authRequired: true },
    component: () => import("../views/data-checker/report/account-gl-movement"),
  },
  {
    path: "/data-checker/serial",
    name: "DataCheckerSerial",
    meta: { title: "Data Checker - Serial (Source Doc)", authRequired: true },
    component: () => import("../views/data-checker/report/serial-data-checker"),
  },
  {
    path: "/transactions/ap-invoice",
    name: "APInvoice",
    meta: { title: "AP Invoice", authRequired: true },
    component: () => import("../views/transactions/ap-invoice/index"),
  },
  {
    path: "/transactions/ap-invoice/form",
    name: "AddAPInvoice",
    meta: { title: "Add AP Invoice", authRequired: true },
    component: () => import("../views/transactions/ap-invoice/form"),
  },
  {
    path: "/transactions/ap-invoice/form/:id",
    name: "EditAPInvoice",
    meta: { title: "Edit AP Invoice", authRequired: true },
    component: () => import("../views/transactions/ap-invoice/form"),
  },
  {
    path: "/transactions/ap-invoice/view",
    name: "ViewAPInvoice",
    meta: { title: "View AP Invoice", authRequired: true },
    component: () => import("../views/transactions/ap-invoice/view"),
  },
  {
    path: "/transactions/cdv",
    name: "CDV",
    meta: { title: "CDV", authRequired: true },
    component: () => import("../views/transactions/cdv/index"),
  },
  {
    path: "/transactions/cdv/form",
    name: "AddCDV",
    meta: { title: "Add CDV", authRequired: true },
    component: () => import("../views/transactions/cdv/form"),
  },
  {
    path: "/transactions/cdv/form/:id",
    name: "EditCDV",
    meta: { title: "Edit CDV", authRequired: true },
    component: () => import("../views/transactions/cdv/form"),
  },
  {
    path: "/transactions/cdv/view",
    name: "ViewCDV",
    meta: { title: "View CDV", authRequired: true },
    component: () => import("../views/transactions/cdv/view"),
  },
  // AP Management
  {
    path: "/accounts-payable/aging/index",
    name: "AcctPyblAging",
    meta: { title: "AP - Aging", authRequired: true },
    component: () => import("../views/ap-management/aging/index"),
  },
  {
    path: "/accounts-payable/aging-doc-num",
    name: "AcctPyblAgingDocNum",
    meta: { title: "AP - Aging Per Doc Num", authRequired: true },
    component: () => import("../views/ap-management/aging-doc-num/index"),
  },
  {
    path: "/accounts-payable/batch/list",
    name: "AcctPyblBatching",
    meta: { title: "AP - Batching", authRequired: true },
    component: () => import("../views/ap-management/batch-/list"),
  },
  {
    path: "/accounts-payable/batch/add",
    name: "AcctPyblBatchAdd",
    meta: { title: "AP - Batching", authRequired: true },
    component: () => import("../views/ap-management/batch-/add"),
  },
  {
    path: "/accounts-payable/batch/edit/:id",
    name: "AcctPyblBatchEdit",
    meta: { title: "AP - Batching", authRequired: true },
    component: () => import("../views/ap-management/batch-/edit"),
  },

  {
    path: "/accounts-payable/batch",
    name: "AccountsPayableBatch",
    meta: { title: "Accounts Payable Batch", authRequired: true },
    component: () => import("../views/ap-management/batch/index"),
  },
  {
    path: "/accounts-payable/batch/form",
    name: "CreateAccountsPayableBatch",
    meta: { title: "Create Accounts Payable Batch", authRequired: true },
    component: () => import("../views/ap-management/batch/form"),
  },
  {
    path: "/accounts-payable/batch/form/:batch_no",
    name: "EditAccountsPayableBatch",
    meta: { title: "Edit Accounts Payable Batch", authRequired: true },
    component: () => import("../views/ap-management/batch/form"),
  },

  {
    path: "/ap-management/reports/summary-of-accounts",
    name: "AccountsPayableSumOfAccounts",
    meta: { title: "Summary of Accounts", authRequired: true },
    component: () => import("../views/ap-management/reports/summary-of-accounts/index"),
  },

  {
    path: "/accounts-payable/overall-payables",
    name: "AccountsPayableOverallPayables",
    meta: { title: "Overall Payables", authRequired: true },
    component: () => import("../views/ap-management/overall-payables/index"),
  },

  {
    path: "/ap-management/reports/summary-of-accounts/form",
    name: "CreateAccountsPayableSumOfAccounts",
    meta: { title: "Create Summary of Reports", authRequired: true },
    component: () => import("../views/ap-management/reports/summary-of-accounts/form"),
  },
  {
    path: "/ap-management/reports/summary-of-accounts/form/:trans_ref",
    name: "EditAccountsPayableSumOfAccounts",
    meta: { title: "Edit Summary of Accounts", authRequired: true },
    component: () => import("../views/ap-management/reports/summary-of-accounts/form"),
  },

  {
    path: "/transactions/supplier-balance-transfer",
    name: "SupplierBalanceTransfer",
    meta: { title: "Balance Transfer", authRequired: true },
    component: () => import("../views/balance-transfer/supplier-balance/index"),
  },
  {
    path: "/transactions/supplier-balance-transfer/form",
    name: "CreateSupplierBalanceTransfer",
    meta: { title: "Create Supplier Balance Transfer", authRequired: true },
    component: () => import("../views/balance-transfer/supplier-balance/form"),
  },
  {
    path: "/transactions/supplier-balance-transfer/form/:trans_ref",
    name: "EditSupplierBalanceTransfer",
    meta: { title: "Edit Supplier Balance Transfer", authRequired: true },
    component: () => import("../views/balance-transfer/supplier-balance/form"),
  },
  {
    path: "/ap-management/bank-balance-transfer",
    name: "BankBalanceTransfer",
    meta: { title: "Bank Balance Transfer", authRequired: true },
    component: () => import("../views/ap-management/bank-balance-transfer/index"),
  },
  {
    path: "/ap-management/bank-balance-transfer/form",
    name: "CreateBankBalanceTransfer",
    meta: { title: "Create Bank Balance Transfer", authRequired: true },
    component: () => import("../views/ap-management/bank-balance-transfer/form"),
  },
  {
    path: "/ap-management/bank-balance-transfer/form/:trans_ref",
    name: "EditBankBalanceTransfer",
    meta: { title: "Edit Bank Balance Transfer", authRequired: true },
    component: () => import("../views/ap-management/bank-balance-transfer/form"),
  },
  //AR DN/CN
  {
    path: "/transactions/note/debit-note",
    name: "ARCreateDebitNote",
    query: { trans_type: "ar", type: "test" },
    meta: {
      title: "Debit Note",
      authRequired: true,
      type: "DN",
      trans_type: "ar",
    },
    component: () => import("../views/transactions/note/index"),
  },
  {
    path: "/transactions/note/credit-note",
    name: "ARCreateCreditNote",
    query: { trans_type: "ar" },
    meta: {
      title: "Credit Note",
      authRequired: true,
      type: "CN",
      trans_type: "ar",
    },
    component: () => import("../views/transactions/note/index"),
  },
  {
    path: "/transactions/note/form/dn",
    name: "ARCreateDebitMemo",
    query: { trans_type: "ar" },
    meta: {
      title: "Debit Note",
      authRequired: true,
      type: "DN",
      trans_type: "ar",
    },
    component: () => import("../views/transactions/note/form"),
  },
  {
    path: "/transactions/note/form/cn",
    name: "ARCreateCreditMemo",
    query: { trans_type: "ar" },
    meta: {
      title: "Credit Note",
      authRequired: true,
      type: "CN",
      trans_type: "ar",
    },
    component: () => import("../views/transactions/note/form"),
  },
  //AP DN/CN
  {
    path: "/transactions/note/debit-note",
    name: "APCreateDebitNote",
    query: { trans_type: "ap" },
    meta: {
      title: "Debit Note",
      authRequired: true,
      type: "DN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/note/index"),
  },
  {
    path: "/transactions/note/credit-note",
    name: "APCreateCreditNote",
    query: { trans_type: "ap" },
    meta: {
      title: "Credit Note",
      authRequired: true,
      type: "CN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/note/index"),
  },
  {
    path: "/transactions/note/form/dn",
    name: "APCreateDebitMemo",
    query: { trans_type: "ap" },
    meta: {
      title: "Debit Note",
      authRequired: true,
      type: "DN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/note/form"),
  },
  {
    path: "/transactions/note/form/cn",
    name: "APCreateCreditMemo",
    query: { trans_type: "ap" },
    meta: {
      title: "Credit Note",
      authRequired: true,
      type: "CN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/note/form"),
  },





  //AR DN/CN
  {
    path: "/transactions/notev2/debit-note",
    name: "ARCreateDebitNoteV2",
    query: { trans_type: "ar" },
    meta: {
      title: "Debit Note",
      authRequired: true,
      type: "DN",
      trans_type: "ar",
    },
    component: () => import("../views/transactions/notev2/index"),
  },
  {
    path: "/transactions/notev2/credit-note",
    name: "ARCreateCreditNoteV2",
    query: { trans_type: "ar" },
    meta: {
      title: "Credit Note",
      authRequired: true,
      type: "CN",
      trans_type: "ar",
    },
    component: () => import("../views/transactions/notev2/index"),
  },
  {
    path: "/transactions/notev2/form/dn",
    name: "ARCreateDebitMemoV2",
    query: { trans_type: "ar" },
    meta: {
      title: "Debit Note",
      type: "DN",
      trans_type: "ar",
      authRequired: true
    },
    component: () => import("../views/transactions/notev2/form"),
  },

  {
    path: "/transactions/notev2/form/cn",
    name: "ARCreateCreditMemoV2",
    query: { trans_type: "ar" },
    meta: {
      title: "Credit Note",

      type: "CN",
      trans_type: "ar",
      authRequired: true
    },
    component: () => import("../views/transactions/notev2/form"),
  },

  // EDIT for AR DN / CN
  {
    path: "/transactions/notev2/form/dn",
    name: "AREditDebitMemoV2",
    meta: {
      title: "Debit Note",
      type: "DN",
      trans_type: "ar",
      authRequired: true
    },
    component: () => import("../views/transactions/notev2/form"),
  },
  {
    path: "/transactions/notev2/form/cn",
    name: "AREditCreditMemoV2",
    meta: {
      title: "Credit Note",
      type: "CN",
      trans_type: "ar",
      authRequired: true
    },
    component: () => import("../views/transactions/notev2/form"),
  },


  //AP DN/CN
  {
    path: "/transactions/notev2/debit-note",
    name: "APCreateDebitNoteV2",
    query: { trans_type: "ap" },
    meta: {
      title: "Debit Note",
      authRequired: true,
      type: "DN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/notev2/index"),
  },
  {
    path: "/transactions/notev2/credit-note",
    name: "APCreateCreditNoteV2",
    query: { trans_type: "ap" },
    meta: {
      title: "Credit Note",
      authRequired: true,
      type: "CN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/notev2/index"),
  },
  {
    path: "/transactions/notev2/form/dn",
    name: "APCreateDebitMemoV2",
    query: { trans_type: "ap" },
    meta: {
      title: "Debit Note",
      authRequired: true,
      type: "DN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/notev2/form"),
  },
  {
    path: "/transactions/notev2/form/cn",
    name: "APCreateCreditMemoV2",
    query: { trans_type: "ap" },
    meta: {
      title: "Credit Note",
      authRequired: true,
      type: "CN",
      trans_type: "ap",
    },
    component: () => import("../views/transactions/notev2/form"),
  },





  // Journal Voucher
  {
    path: "/transactions/journal-vouchers",
    name: "JournalVoucher",
    meta: { title: "Journal Voucher", authRequired: true },
    component: () => import("../views/transactions/journal-vouchers/index"),
  },
  {
    path: "/transactions/journal-vouchers/form",
    name: "AddJournalVoucher",
    meta: { title: "Add Journal Voucher", authRequired: true },
    component: () => import("../views/transactions/journal-vouchers/form"),
  },
  {
    path: "/transactions/journal-vouchers/form/:id",
    name: "EditJournalVoucher",
    meta: { title: "Edit Journal Voucher", authRequired: true },
    component: () => import("../views/transactions/journal-vouchers/form"),
  },
  {
    path: "/transactions/journal-vouchers/voucher/:id",
    name: "ViewJournalVoucher",
    meta: { title: "View Journal Voucher", authRequired: true },
    component: () =>
      import("../views/transactions/journal-vouchers/view-voucher"),
  },
  // Tax Management Input Vat
  {
    path: "/tax-management/input-vat-conversion",
    name: "TaxMngtInputVAT",
    meta: { title: "Input VAT - Conversion", authRequired: true },
    component: () =>
      import("../views/tax-management/input-vat-conversion/index"),
  },
  {
    path: "/tax-management/input-vat-conversion/form",
    name: "AddTaxMngtInputVAT",
    meta: { title: "Add Input VAT - COnversion", authRequired: true },
    component: () =>
      import("../views/tax-management/input-vat-conversion/form"),
  },
  {
    path: "/tax-management/input-vat-conversion/form/:id",
    name: "EditTaxMngtInputVAT",
    meta: { title: "Edit Input VAT - COnversion", authRequired: true },
    component: () =>
      import("../views/tax-management/input-vat-conversion/form"),
  },
  {
    path: "/tax-management/input-vat-conversion/voucher/:id",
    name: "ViewTaxMngtInputVAT",
    meta: { title: "View Input VAT - COnversion", authRequired: true },
    component: () =>
      import("../views/tax-management/input-vat-conversion/view-voucher"),
  },
  {
    path: "/tax-management/alpha-list",
    name: "TaxMngtAlphaList",
    meta: { title: "Alpha List", authRequired: true },
    component: () => import("../views/tax-management/alpha-list/index"),
  },

  // Tax Management Output Vat
  {
    path: "/tax-management/output-vat-conversion",
    name: "TaxMngtOutputVAT",
    meta: { title: "Output VAT - Conversion", authRequired: true },
    component: () =>
      import("../views/tax-management/output-vat-conversion/index"),
  },
  {
    path: "/tax-management/output-vat-conversion/form",
    name: "AddTaxMngtOutputVAT",
    meta: { title: "Add Output VAT - Conversion", authRequired: true },
    component: () =>
      import("../views/tax-management/output-vat-conversion/form"),
  },
  {
    path: "/tax-management/output-vat-conversion/form/:id",
    name: "EditTaxMngtOutputVAT",
    meta: { title: "Edit Output VAT - Conversion", authRequired: true },
    component: () =>
      import("../views/tax-management/output-vat-conversion/form"),
  },
  {
    path: "/tax-management/output-vat-conversion/voucher/:id",
    name: "ViewTaxMngtOutputVAT",
    meta: { title: "View Output VAT - Conversion", authRequired: true },
    component: () =>
      import("../views/tax-management/output-vat-conversion/view-voucher"),
  },

  // Tax Management Output Vat
  {
    path: "/tax-management/tax-settlement",
    name: "TaxSettlement",
    meta: { title: "Tax Settlement", authRequired: true },
    component: () => import("../views/tax-management/tax-settlement/index"),
  },

  {
    path: "/tax-management/tax-settlement-create",
    name: "CreateTaxSettlement",
    meta: { title: "Create Tax Settlement", authRequired: true },
    component: () => import("../views/tax-management/tax-settlement/form"),
  },

  // URL not yet exists
  {
    path: "/tax-management/tax-report",
    name: "TaxReport",
    meta: { title: "Tax Report", authRequired: true },
    component: () => import("../views/tax-management/tax-report/index"),
  },

  {
    path: "/government-compliance/reports/in-out-vat",
    name: "InputOutputVat",
    meta: { title: "Input / Output Vat", authRequired: true },
    component: () =>
      import("../views/tax-management/vat-report/input-ouput-vat"),
  },
  {
    path: "/government-compliance/reports/vat-monitoring",
    name: "VATMonitoring",
    meta: { title: "VAT Monitoring", authRequired: true },
    component: () =>
      import("../views/tax-management/vat-monitoring/index"),
  },
  {
    path: "/government-compliance/reports/vat-monitoring-create",
    name: "CreateVATMonitoring",
    meta: { title: "Create VAT Monitoring", authRequired: true },
    component: () =>
      import("../views/tax-management/vat-monitoring/form"),
  },
  {
    path: "/government-compliance/reports/vat-monitoring-update/:batch_no",
    name: "EditVATMonitoring",
    meta: { title: "Edit VAT Monitoring", authRequired: true },
    component: () => import("../views/tax-management/vat-monitoring/form"),
  },

  // VAT Settlement
  {
    path: "/tax-management/vat-settlement",
    name: "VATSettlement",
    meta: { title: "VAT Settlement", authRequired: true },
    component: () => import("../views/tax-management/vat-settlement/index"),
  },

  {
    path: "/tax-management/vat-settlement-create",
    name: "CreateVATSettlement",
    meta: { title: "Create VAT Settlement", authRequired: true },
    component: () => import("../views/tax-management/vat-settlement/form"),
  },
  {
    path: "/tax-management/vat-settlement-update/:batch_no",
    name: "EditVATSettlement",
    meta: { title: "Edit VAT Settlement", authRequired: true },
    component: () => import("../views/tax-management/vat-settlement/form"),
  },

  // VAT ZERO-RATED & Exempt Report
  {
    path: "/tax-management/vat-sales-report",
    name: "VatZeroRated&Exempt",
    meta: { title: "VAT ZERO-RATED & Exempt Report", authRequired: true },
    component: () =>
      import("../views/tax-management/vat-report/vat-zero-rate-exempt"),
  },
  // SAWT REPORT
  {
    path: "/tax-management/sawt-report",
    name: "SAWTReport",
    meta: { title: "SAWT Report", authRequired: true },
    component: () => import("../views/tax-management/vat-report/sawt"),
  },

  // CWT MONITORING
  {
    path: "/tax-management/cwt-monitoring",
    name: "CWTMonitoringReport",
    meta: { title: "CWT Monitoring Report", authRequired: true },
    component: () =>
      import("../views/tax-management/vat-report/cwt-monitoring"),
  },

  {
    path: "/ap-management/sundry-invoice",
    name: "SundryInvoice",
    meta: { title: "Sundry Invoice", authRequired: true },
    component: () => import("../views/ap-management/sundry-invoice/index"),
  },
  {
    path: "/ap-management/sundry-invoice/form",
    name: "CreateSundryInvoice",
    meta: { title: "Create Sundry Invoice", authRequired: true },
    component: () => import("../views/ap-management/sundry-invoice/form"),
  },
  {
    path: "/ap-management/sundry-invoice/form/:id",
    name: "EditSundryInvoice",
    meta: { title: "Edit Sundry Invoice", authRequired: true },
    component: () => import("../views/ap-management/sundry-invoice/form"),
  },
  {
    path: "/ap-management/sundry-payment",
    name: "SundryPayment",
    meta: { title: "Sundry Payment", authRequired: true },
    component: () => import("../views/ap-management/sundry-payment/index"),
  },
  {
    path: "/ap-management/sundry-payment/form",
    name: "CreateSundryPayment",
    meta: { title: "Create Sundry Payment", authRequired: true },
    component: () => import("../views/ap-management/sundry-payment/form"),
  },
  {
    path: "/ap-management/sundry-payment/form/:id",
    name: "EditSundryPayment",
    meta: { title: "Edit Sundry Payment", authRequired: true },
    component: () => import("../views/ap-management/sundry-payment/form"),
  },
  // Account Payable SOA Aging Report
  {
    path: "/reports/account-payable/soa/aging",
    name: "AcctPyblSOAAging",
    meta: { title: "AP - SOA", authRequired: true },
    component: () => import("../views/reports/account-payable/soa/aging"),
  },
  {
    path: "/reports/account-payable/soa/service-type",
    name: "AcctPyblSOAAgingByServiceType",
    meta: { title: "AP - SOA", authRequired: true },
    component: () =>
      import("../views/reports/account-payable/soa/service-type"),
  },
  {
    path: "/ap-management/prepayment",
    name: "Prepayment",
    meta: { title: "Prepayment", authRequired: true },
    component: () => import("../views/ap-management/prepayment/index"),
  },
  {
    path: "/ap-management/prepayment/form",
    name: "CreatePrepayment",
    meta: { title: "Create Prepayment", authRequired: true },
    component: () => import("../views/ap-management/prepayment/form"),
  },
  {
    path: "/ap-management/prepayment/form/:id",
    name: "EditPrepayment",
    meta: { title: "Edit Prepayment", authRequired: true },
    component: () => import("../views/ap-management/prepayment/form"),
  },
  {
    path: "/ap-management/prepayment/view",
    name: "ViewPrepayment",
    meta: { title: "View Prepayment", authRequired: true },
    component: () => import("../views/ap-management/prepayment/view"),
  },
  {
    path: "/ap-management/payment-releasing",
    name: "PaymentReleasing",
    meta: { title: "Payment Releasing", authRequired: true },
    component: () => import("../views/ap-management/payment-releasing/index"),
  },
  {
    path: "/ap-management/payment-releasing/view",
    name: "ViewPaymentReleasing",
    meta: { title: "Payment Releasing", authRequired: true },
    component: () => import("../views/ap-management/payment-releasing/view"),
  },

  // AR Management
  {
    path: "/ar-management/reports/payment-history",
    name: "PaymentHistory",
    meta: { title: "Payment History", authRequired: true },
    component: () =>
      import("../views/ar-management/reports/payment-history/index"),
  },

  {
    path: "/ar-management/advances",
    name: "Advances",
    meta: { title: "Advances", authRequired: true },
    component: () => import("../views/ar-management/advances/index"),
  },

  // Tag Inovices
  {
    path: "/ar-management/tag-invoices",
    name: "TagInvoices",
    meta: { title: "Tag Invoices", authRequired: true },
    component: () => import("../views/ar-management/tag-invoices/index"),
  },
  {
    path: "/ar-management/tag-invoices/form",
    name: "CreateTagInvoices",
    meta: { title: "Create Tag Invoices", authRequired: true },
    component: () => import("../views/ar-management/tag-invoices/form"),
  },
  {
    path: "/ar-management/tag-invoices/form/:trans_ref",
    name: "EditTagInvoices",
    meta: { title: "Edit Tag Invoices", authRequired: true },
    component: () => import("../views/ar-management/tag-invoices/form"),
  },

  // Adjustment Summary
  {
    path: "/ar-management/adjustment-summary",
    name: "ARAdjustmentSummary",
    meta: { title: "AR Adjustment Summary", authRequired: true },
    component: () => import("../views/ar-management/adjustment-summary/index"),
  },

  // Billing Process Time Report
  {
    path: "/ar-management/invoice-logs",
    name: "InvoiceLogs",
    meta: { title: "Billing Process Time Report", authRequired: true },
    component: () => import("../views/ar-management/invoice-logs/index"),
  },

  // Cash Management
  {
    path: "/cash-management/dashboard",
    name: "CashManagementDashboard",
    meta: { title: "Cash Management Dashboard", authRequired: true },
    component: () => import("../views/cash-management/dashboard/index"),
  },
  {
    path: "/cash-management/bank-statement",
    name: "BankStatement",
    meta: { title: "Bank Statement", authRequired: true },
    component: () => import("../views/cash-management/bank-statement/index"),
  },
  {
    path: "/cash-management/cash-positions",
    name: "CashPositions",
    meta: { title: "Cash Positions", authRequired: true },
    component: () => import("../views/cash-management/cash-positions/index"),
  },
  {
    path: "/cash-management/collection",
    name: "CollectionReport",
    meta: { title: "Collection", authRequired: true },
    component: () => import("../views/cash-management/collection/index"),
  },
  {
    path: "/cash-management/daily-collection",
    name: "DailyCollectionReport",
    meta: { title: "Daily Collection", authRequired: true },
    component: () => import("../views/cash-management/daily-collection/index"),
  },
  {
    path: "/cash-management/per-bank-activity",
    name: "PerBankActivityReport",
    meta: { title: "Per Bank Activity", authRequired: true },
    component: () => import("../views/cash-management/per-bank-activity/index"),
  },
  {
    path: "/cash-management/daily-bank-transactions",
    name: "DailyBankTransactions",
    meta: { title: "Daily Bank Transactions", authRequired: true },
    component: () =>
      import("../views/cash-management/daily-bank-transactions/index"),
  },
  {
    path: "/cash-management/disbursement",
    name: "DisbursementReport",
    meta: { title: "Disbursement Report", authRequired: true },
    component: () => import("../views/cash-management/disbursement/index"),
  },
  {
    path: "/cash-management/overall",
    name: "OverallReport",
    meta: { title: "Overvall Report", authRequired: true },
    component: () => import("../views/cash-management/overall/index"),
  },
  {
    path: "/cash-management/bank-recon/form",
    name: "BankReconUpload",
    meta: { title: "Bank Recon Upload", authRequired: true },
    component: () => import("../views/cash-management/bank-recon/form"),
  },
  {
    path: "/cash-management/bank-running-balance",
    name: "BankRunningBalance",
    meta: { title: "Bank Running Balance", authRequired: true },
    component: () => import("../views/cash-management/bank-running-balance/index"),
  },
  {
    path: "/cash-management/monthly-cash-flow",
    name: "MonthlyCashFlow",
    meta: { title: "Monthly Cash Flow", authRequired: true },
    component: () => import("../views/cash-management/monthly-cash-flow/index"),
  },
  {
    path: "/cash-management/check-monitoring",
    name: "CheckMonitoring",
    meta: { title: "Check Monitoring", authRequired: true },
    component: () => import("../views/cash-management/check-monitoring/index"),
  },
  {
    path: "/cash-management/document-tagging",
    name: "DocumentTagging",
    meta: { title: "Document Tagging", authRequired: true },
    component: () => import("../views/cash-management/document-tagging/index"),
  },
  //Audit Logs
  {
    path: "/reports/audit-logs",
    name: "AuditLogs",
    meta: { title: "Audit Logs", authRequired: true },
    component: () => import("../views/reports/audit-logs/index"),
  },
  {
    path: "/maintenance/form-types",
    name: "FormTypes",
    meta: { title: "Form Types", authRequired: true },
    component: () => import("../views/maintenance/printable-forms/types"),
  },
  {
    path: "/maintenance/form-items",
    name: "FormItems",
    meta: { title: "Form Items", authRequired: true },
    component: () => import("../views/maintenance/printable-forms/form_items"),
  },
  {
    path: "/maintenance/form-templates",
    name: "FormTemplates",
    meta: { title: "Form Templates", authRequired: true },
    component: () =>
      import("../views/maintenance/printable-forms/templates/index"),
  },
  {
    path: "/printing/bank-forms",
    name: "BankFormsPrinting",
    meta: { title: "Bank Forms Printing", authRequired: true },
    component: () =>
      import("../views/ap-management/bank-forms/index"),
  },
  {
    path: "/bank-forms/printing",
    name: "formPrinting",
    meta: { title: "Forms Printing", authRequired: true },
    component: () =>
      import("../views/ap-management/bank-forms/form"),
  },
  {
    path: "/maintenance/form-template-builder",
    name: "CreateFormTemplate",
    meta: { title: "Create Form Template", authRequired: true },
    component: () =>
      import("../views/maintenance/printable-forms/templates/form"),
  },
  {
    path: "/maintenance/form-template-builder/:id",
    name: "EditFormTemplate",
    meta: { title: "Edit Form Template", authRequired: true },
    component: () =>
      import("../views/maintenance/printable-forms/templates/form"),
  },
  // Production Reports
  {
    path: "/production-reports/overall",
    name: "ProductionReportOverall",
    meta: { title: "Production Report Overall", authRequired: true },
    component: () => import("../views/pages/production-reports/overall/index"),
  },
  {
    path: "/production-reports/config-reports",
    name: "ConfigReports",
    meta: { title: "Config Reports", authRequired: true },
    component: () =>
      import("../views/pages/production-reports/config-reports/index"),
  },
  {
    path: "/production-reports/per-services",
    name: "PerServices",
    meta: { title: "Per Services", authRequired: true },
    component: () =>
      import("../views/pages/production-reports/per-services/index"),
  },
  {
    path: "/production-reports/per-services-details",
    name: "Per Services Details",
    meta: { title: "Per Services Details", authRequired: true },
    component: () =>
      import("../views/pages/production-reports/per-services-details/index"),
  },
  {
    path: "/production-reports/account-inquiries",
    name: "AccountInquiries",
    meta: { title: "Account Inquiries", authRequired: true },
    component: () =>
      import("../views/pages/production-reports/account-inquiries/index"),
  },
  {
    path: "/production-reports/profit-and-loss",
    name: "ProfitAndLoss",
    meta: { title: "Profit And Loss", authRequired: true },
    component: () =>
      import("../views/pages/production-reports/profit-and-loss/index"),
  },

  // Executive Reports
  {
    path: "/executive-reports/overall",
    name: "ExecutiveReportOverall",
    meta: { title: "Executive Report Overall", authRequired: true },
    component: () => import("../views/pages/executive-reports/overall/index"),
  },
  {
    path: "/executive-reports/dashboard",
    name: "ExecutiveDashboard",
    meta: { title: "Executive Dashboard", authRequired: true },
    component: () => import("../views/pages/executive-reports/dashboard/index"),
  },
  // Audit and Validation
  {
    path: "/audit-validation/document-audit-trail",
    name: "DocumentAuditTrail",
    meta: { title: "Document Audit Trail", authRequired: true },
    component: () =>
      import("../views/audit-validation/document-audit-trail/index"),
  },
  // Billing
  {
    path: "/transactions/billing",
    name: "BillingList",
    meta: { title: "Billing", authRequired: true },
    component: () => import("../views/billing/index.vue"),
  },
  {
    path: "/transactions/billing/form/:id",
    name: "EditBilling",
    meta: { title: "Edit Billing", authRequired: true },
    component: () => import("../views/billing/form"),
  },
  {
    path: "/transactions/billing/form",
    name: "AddBilling",
    meta: { title: "Add Billing", authRequired: true },
    component: () => import("../views/billing/form.vue"),
  },

  // Services
  {
    path: "/maintenance/services",
    name: "Services",
    meta: { title: "Services", authRequired: true },
    component: () => import("../views/maintenance/services/index"),
  },

  // Charges
  {
    path: "/maintenance/charges",
    name: "Charges",
    meta: { title: "Charges", authRequired: true },
    component: () => import("../views/maintenance/charges/index"),
  },

  // Charges Groups
  {
    path: "/maintenance/charges-groups",
    name: "ChargesGroups",
    meta: { title: "Charges Groups", authRequired: true },
    component: () => import("../views/maintenance/charges-groups/index"),
  },
  // CI Series
  {
    path: "/maintenance/ci-series/index",
    name: "CreateCISeries",
    meta: { title: "Create CI Series", authRequired: true },
    component: () => import("../views/maintenance/ci-series/index"),
  },
  // Client Management Accreditataion Template
  {
    path: "/maintenance/accreditation-template",
    name: "AccreditationTemplate",
    meta: { title: "Accreditation Template", authRequired: true },
    component: () =>
      import("../views/maintenance/accreditation-template/index"),
  },
  // Client Management Accreditataion External Form
  {
    path: "/client-accreditation-form/ext/:token",
    name: "ExtAccreditationTemplate",
    meta: { title: "External Accreditation Template", authRequired: false },
    component: () => import("../views/maintenance/clients/ext_form"),
  },
  // Budget Management
  {
    path: "/budget/budget-management",
    name: "BudgetMgmt",
    meta: { title: "Budget Management", authRequired: true },
    component: () => import("../views/budget/budget-management"),
  },
  {
    path: "/transactions/prepayment-voucher",
    name: "PrepaymentVoucherList",
    meta: { title: "Prepayment Voucher", authRequired: true },
    component: () => import("../views/transactions/prepayment-voucher/index"),
  },
  {
    path: "/transactions/prepayment-voucher/form",
    name: "PrepaymentVoucherForm",
    meta: { title: "Prepayment Voucher Entry", authRequired: true },
    component: () => import("../views/transactions/prepayment-voucher/form"),
  },
  {
    path: "/transactions/prepayment-voucher/form/:id",
    name: "EditPrepaymentVoucherForm",
    meta: { title: "Prepayment Voucher Entry", authRequired: true },
    component: () => import("../views/transactions/prepayment-voucher/form"),
  },
  {
    path: "/transactions/recurring-invoice-template",
    name: "RecurringExpense",
    meta: { title: "Recurring Expense", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-invoice-template/index"),
  },
  {
    path: "/transactions/recurring-invoice-template/form",
    name: "RecurringExpenseForm",
    meta: { title: "Recurring Expense Entry", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-invoice-template/form"),
  },
  {
    path: "/transactions/recurring-invoice-template/form/:id",
    name: "EditRecurringExpenseForm",
    meta: { title: "Edit Recurring Expense Entry", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-invoice-template/form"),
  },
  {
    path: "/maintenance/check-series/index",
    name: "CreateCheckSeries",
    meta: { title: "Create Check Series", authRequired: true },
    component: () => import("../views/maintenance/check-series/index"),
  },

  // Inventory Management
  {
    path: "/inventory-management/stock-movement",
    name: "StockMovement",
    meta: { title: "Stock Movement", authRequired: true },
    component: () => import("../views/inventory-management/stock-movement/index"),
  },
  {
    path: "/inventory-management/project-costing",
    name: "ProjectCosting",
    meta: { title: "Project Costing", authRequired: true },
    component: () =>
      import(
        "../views/inventory-management/project-costing/create-project/index"
      ),
  },
  {
    path: "/inventory-management/dashboard",
    name: "InventoryDashboard",
    meta: { title: "Inventory Dashboard", authRequired: true },
    component: () => import("../views/inventory-management/dashboard/index"),
  },
  {
    path: "/inventory-management/project-costing/categories",
    name: "Categories",
    meta: { title: "Categories", authRequired: true },
    component: () =>
      import("../views/inventory-management/project-costing/categories/index"),
  },
  {
    path: "/inventory-management/location",
    name: "Bin Location",
    meta: { title: "Bin Location", authRequired: true },
    component: () => import("../views/inventory-management/location/index"),
  },
  {
    path: "/inventory-management/location-category",
    name: "Location Category",
    meta: { title: "Location Category", authRequired: true },
    component: () =>
      import("../views/inventory-management/location/category/index"),
  },
  {
    path: "/inventory-management/categories",
    name: "Inventory Categories",
    meta: { title: "Inventory Categories", authRequired: true },
    component: () =>
      import("../views/inventory-management/categories/index"),
  },

  {
    path: "/inventory-management/satellite",
    name: "Satellites",
    meta: { title: "Satellites", authRequired: true },
    component: () =>
      import("../views/inventory-management/satellite/index"),
  },

  {
    path: "/inventory-management/maintenance/warehouses",
    name: "Warehouses",
    meta: { title: "Warehouses", authRequired: true },
    component: () =>
      import("../views/inventory-management/maintenance/warehouses/index"),
  },

  {
    path: "/inventory-management/maintenance/item-account-setup",
    name: "ItemAccountSetup",
    meta: { title: "Item Account Setup", authRequired: true },
    component: () =>
      import("../views/inventory-management/maintenance/item-account-setup/index"),
  },

  {
    path: "/inventory-management/maintenance/tools-depreciation",
    alias: ["/inventory-management/maintenance/tools-depreciation/"],
    name: "ToolsDepreciation",
    meta: { title: "Tools Depreciation", authRequired: true },
    component: () =>
      import("../views/inventory-management/maintenance/tools-depreciation/index.vue"),
  },

  {
    path: "/inventory-management/maintenance/tools-depreciation-applied",
    alias: ["/inventory-management/maintenance/tools-depreciation-applied/"],
    name: "ToolsDepreciationApplied",
    meta: { title: "Tools Depreciation Applied Maintenance", authRequired: true },
    component: () =>
      import("../views/inventory-management/maintenance/tools-depreciation-applied/index.vue"),
  },

  {
    path: "/inventory-management/withdrawal",
    name: "Withdrawal",
    meta: { title: "Withdrawal", authRequired: true },
    component: () => import("../views/inventory-management/withdrawal"),
  },

  {
    path: "/inventory-management/withdrawal/form",
    name: "WithdrawalForm",
    meta: { title: "Withdrawal Form", authRequired: true },
    component: () => import("../views/inventory-management/withdrawal/form"),
  },

  {
    path: "/inventory-management/withdrawal/view/:id",
    name: "ViewWithdrawal",
    meta: { title: "View Withdrawal", authRequired: true },
    component: () => import("../views/inventory-management/withdrawal/form"),
  },

  {
    path: "/inventory-management/return",
    name: "ReturnStock",
    meta: { title: "Return Stock", authRequired: true },
    component: () => import("../views/inventory-management/return"),
  },

  {
    path: "/inventory-management/return/form",
    name: "ReturnStockForm",
    meta: { title: "Return Stock Form", authRequired: true },
    component: () => import("../views/inventory-management/return/form"),
  },

  {
    path: "/inventory-management/return/view/:id",
    name: "ViewReturnStockForm",
    meta: { title: "View Return Stock Form", authRequired: true },
    component: () => import("../views/inventory-management/return/form"),
  },

  {
    path: "/inventory-management/repaired",
    name: "RepairedToolsList",
    meta: { title: "For Repaired List", authRequired: true },
    component: () => import("../views/inventory-management/repaired/index.vue"),
  },

  {
    path: "/inventory-management/found-items",
    name: "FoundItemsList",
    meta: { title: "Found Items List", authRequired: true },
    component: () => import("../views/inventory-management/found-items/index.vue"),
  },

  {
    path: "/inventory-management/retired",
    name: "RetiredInventoryList",
    meta: { title: "Retired Inventory List", authRequired: true },
    component: () => import("../views/inventory-management/retired/index.vue"),
  },

  {
    path: "/inventory-management/deployment-retired",
    name: "DeploymentRetired",
    meta: { title: "Deployment Retired", authRequired: true },
    component: () => import("../views/inventory-management/deployment-retired"),
  },

  {
    path: "/inventory-management/deployment-retired/form",
    name: "DeploymentRetiredForm",
    meta: { title: "Deployment Retired Form", authRequired: true },
    component: () => import("../views/inventory-management/deployment-retired/form"),
  },

  {
    path: "/inventory-management/deployment-retired/view/:id",
    name: "ViewDeploymentRetired",
    meta: { title: "View Deployment Retired", authRequired: true },
    component: () => import("../views/inventory-management/deployment-retired/form"),
  },

  {
    path: "/inventory-management/deployment",
    name: "Deployment",
    meta: { title: "Deployment", authRequired: true },
    component: () => import("../views/inventory-management/deployment"),
  },

  {
    path: "/inventory-management/deployment/form",
    name: "DeploymentForm",
    meta: { title: "Deployment Form", authRequired: true },
    component: () => import("../views/inventory-management/deployment/form"),
  },

  {
    path: "/inventory-management/deployment/view/:id",
    name: "ViewDeployment",
    meta: { title: "View Deployment", authRequired: true },
    component: () => import("../views/inventory-management/deployment/form"),
  },

  {
    path: "/inventory-management/reports/bom-report",
    name: "BOMReport",
    meta: { title: "Inventory BOM Reports", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/bom-report"),
  },

  {
    path: "/inventory-management/report/deployed-assets",
    name: "ReportDeployedAssets",
    meta: { title: "Inventory Deployed Assets", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/deployed-assets"),
  },

  {
    path: "/inventory-management/report/returned-assets",
    name: "ReportReturnedAssets",
    meta: { title: "Inventory Returned Assets", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/returned-assets"),
  },

  {
    path: "/inventory-management/report/current-stocks",
    name: "ReportCurrentStocks",
    meta: { title: "Inventory Current Stocks", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/current-stocks"),
  },

  {
    path: "/inventory-management/report/stock-movement",
    name: "ReportStockMovement",
    meta: { title: "Inventory Stock Movement List", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/stock-movement"),
  },
  {
    path: "/inventory-management/report/withdrawal-stock-movement",
    name: "ReportWithdrawalStockMovement",
    meta: { title: "Withdrawal Stock Movement Report", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/withdrawal-report"),
  },
  {
    path: "/inventory-management/report/return-stock-movement",
    name: "ReportReturnStockMovement",
    meta: { title: "Return Stock Movement Report", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/return-report"),
  },
  {
    path: "/inventory-management/report/repaired-stock-movement",
    name: "ReportRepairedStockMovement",
    meta: { title: "Repaired Stock Movement Report", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/repaired-report"),
  },
  {
    path: "/inventory-management/report/retired-stock-movement",
    name: "ReportRetiredStockMovement",
    meta: { title: "Retired Stock Movement Report", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/retired-report"),
  },
  {
    path: "/inventory-management/report/scrap-stock-movement",
    name: "ReportScrapStockMovement",
    meta: { title: "Scrap Stock Movement Report", authRequired: true },
    component: () =>
      import("../views/inventory-management/reports/scrap-report"),
  },
  {
    path: "/transactions/expense",
    name: "APExpense",
    meta: { title: "AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/index"),
  },
  {
    path: "/transactions/expense/form",
    name: "AddExpense",
    meta: { title: "Add AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/form"),
  },
  //fn transmittal
  {
    path: "/transactions/expense/fn",
    name: "FnTransmittals",
    meta: { title: "FN Transmittals", authRequired: true },
    component: () => import("../views/transactions/expense/fn/index"),
  },
  {
    path: "/transactions/expense/fn/form",
    name: "AddFNTransmittal",
    meta: { title: "Add FN Transmittal", authRequired: true },
    component: () => import("../views/transactions/expense/fn/form"),
  },
  {
    path: "/transactions/expense/fn/form/:id",
    name: "EditFNTransmittal",
    meta: { title: "Edit FN Transmittal", authRequired: true },
    component: () => import("../views/transactions/expense/fn/form"),
  },
  {
    path: "/transactions/expense/fn/view",
    name: "ViewFnTrasmittal",
    meta: { title: "View FN Transmittal", authRequired: true },
    component: () => import("../views/transactions/expense/fn/view"),
  },
  //fn transmittal

  //sundry transmittal
  {
    path: "/transactions/expense/sundry",
    name: "Sundry",
    meta: { title: "Sundry", authRequired: true },
    component: () => import("../views/transactions/expense/sundry/index"),
  },
  {
    path: "/transactions/expense/sundry/form",
    name: "AddSundry",
    meta: { title: "Add Sundry", authRequired: true },
    component: () => import("../views/transactions/expense/sundry/form"),
  },
  {
    path: "/transactions/expense/sundry/form/:id",
    name: "EditSundry",
    meta: { title: "Edit Sundry", authRequired: true },
    component: () => import("../views/transactions/expense/sundry/form"),
  },
  {
    path: "/transactions/expense/sundry/view",
    name: "ViewSundry",
    meta: { title: "View Sundry", authRequired: true },
    component: () => import("../views/transactions/expense/sundry/view"),
  },
  //sundry transmittal

  //direct transmittal
  {
    path: "/transactions/expense/direct",
    name: "DirectExpenses",
    meta: { title: "Direct Expense", authRequired: true },
    component: () => import("../views/transactions/expense/direct/index"),
  },
  {
    path: "/transactions/expense/direct/form",
    name: "AddDirectExpense",
    meta: { title: "Add Direct Expense", authRequired: true },
    component: () => import("../views/transactions/expense/direct/form"),
  },
  {
    path: "/transactions/expense/direct/form/:id",
    name: "EditDirectExpense",
    meta: { title: "Edit Direct Expense", authRequired: true },
    component: () => import("../views/transactions/expense/direct/form"),
  },
  {
    path: "/transactions/expense/direct/view",
    name: "ViewDirectExpense",
    meta: { title: "View Direct Expense", authRequired: true },
    component: () => import("../views/transactions/expense/direct/view"),
  },
  //direct transmittal

  //expense invoice item linking (Direct/Sundry -> PR or manual items, feeds Asset Capitalization)
  {
    path: "/transactions/expense/item-link",
    name: "ExpenseItemLink",
    meta: { title: "Expense Item Linking", authRequired: true },
    component: () => import("../views/transactions/expense/item-link/index"),
  },
  {
    path: "/transactions/expense/item-link/:ap_invoice_no",
    name: "ExpenseItemLinkForm",
    meta: { title: "Link Items to Invoice", authRequired: true },
    component: () => import("../views/transactions/expense/item-link/form"),
  },
  //expense invoice item linking


  //start of AP Trade
  {
    path: "/transactions/expense/ap-trade",
    name: "APTrade",
    meta: { title: "AP Trade Transmittals", authRequired: true },
    component: () => import("../views/transactions/expense/trade/index"),
  },
  {
    path: "/transactions/expense/ap-trade/form",
    name: "AddAPTrade",
    meta: { title: "Add AP Trade", authRequired: true },
    component: () => import("../views/transactions/expense/trade/form"),
  },
  {
    path: "/transactions/expense/ap-trade/form/:id",
    name: "EditAPTrade",
    meta: { title: "Edit AP Trade", authRequired: true },
    component: () => import("../views/transactions/expense/trade/form"),
  },
  {
    path: "/transactions/expense/ap-trade/view",
    name: "ViewAPTrade",
    meta: { title: "View AP Trade", authRequired: true },
    component: () => import("../views/transactions/expense/trade/view"),
  },

  //end of AP Trade


  {
    path: "/transactions/expense/form/:id",
    name: "EditExpense",
    meta: { title: "Edit AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/trade/form"),
  },
  {
    path: "/transactions/expense/view",
    name: "ViewExpense",
    meta: { title: "View AP Invoice", authRequired: true },
    component: () => import("../views/transactions/expense/view"),
  },

  // APExpenseSOBIPrepmt
  // SOBI
  {
    path: "/transactions/expense/SOBI",
    name: "APExpenseSOBI",
    meta: { title: "AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/sobi/sobi-index"),
  },
  {
    path: "/transactions/expense/SOBI/form",
    name: "AddExpenseSOBI",
    meta: { title: "Add AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/sobi/sobi-form"),
  },
  {
    path: "/transactions/expense/SOBI/form/:id",
    name: "EditExpenseSOBI",
    meta: { title: "Edit AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/sobi/sobi-form"),
  },
  {
    path: "/transactions/expense/SOBI/view",
    name: "ViewExpenseSOBI",
    meta: { title: "View AP Invoice", authRequired: true },
    component: () => import("../views/transactions/expense/sobi/sobi-view"),
  },


  // Prepayment
  {
    path: "/transactions/expense/Prepayment",
    name: "APExpensePrepayment",
    meta: { title: "AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/prepayment/prepmt-index"),
  },
  {
    path: "/transactions/expense/Prepayment/form",
    name: "AddExpensePrepayment",
    meta: { title: "Add AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/prepayment/prepmt-form"),
  },
  {
    path: "/transactions/expense/Prepayment/form/:id",
    name: "EditExpensePrepayment",
    meta: { title: "Edit AP Expense", authRequired: true },
    component: () => import("../views/transactions/expense/prepayment/prepmt-form"),
  },
  {
    path: "/transactions/expense/Prepayment/view",
    name: "ViewExpensePrepayment",
    meta: { title: "View AP Invoice", authRequired: true },
    component: () => import("../views/transactions/expense/prepayment/prepmt-view"),
  },

  //Recurring voucher tempalte
  {
    path: "/transactions/recurring-voucher-template/form",
    name: "CreateRecurringVoucherTemplate",
    meta: { title: "Create Recurring Voucher Template", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-voucher-template/form"),
  },
  {
    path: "/transactions/recurring-voucher-template/jv",
    name: "RecurringVoucherTemplateJv",
    meta: { title: "Recurring Journal Voucher", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-voucher-template/jv"),
  },
  {
    path: "/transactions/recurring-voucher-template/jv_report",
    name: "RecurringVoucherTemplateJvReport",
    meta: { title: "Recurring Journal Voucher", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-voucher-template/jv_report"),
  },

  {
    path: "/transactions/recurring-voucher-template",
    name: "RecurringVoucherTemplates",
    meta: { title: "Recurring Voucher Template", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-voucher-template/index"),
  },
  {
    path: "/transactions/recurring-voucher-template/:id",
    name: "EditRecurringVoucherTemplates",
    meta: { title: "Recurring Voucher Template", authRequired: true },
    component: () =>
      import("../views/transactions/recurring-voucher-template/form"),
  },

  // Advances Report
  {
    path: "/reports/advances",
    name: "AdvancesReport",
    meta: { title: "Advances Report", authRequired: true },
    component: () => import("../views/reports/advances"),
  },

  // Expenses Report
  {
    path: "/reports/expenses",
    name: "ExpensesReport",
    meta: { title: "Expenses Report", authRequired: true },
    component: () => import("../views/reports/expenses"),
  },

  // Invoice Search
  {
    path: "/search-invoice",
    name: "SearchInvoice",
    meta: { title: "Search Invoice", authRequired: true },
    component: () => import("../views/data-checker/search-invoice"),
  },
  // MultiCurrency Settlement 
  {
    path: "/transactions/currency-settlement",
    name: "CurrencySettlementList",
    meta: { title: "Currency Settlement", authRequired: true },
    component: () => import("../views/transactions/currency-settlement"),
  },

  {
    path: "/transactions/currency-settlement/form",
    name: "CreateCurrencySettlement",
    meta: { title: "Create Currency Settlement", authRequired: true },
    component: () => import("../views/transactions/currency-settlement/form"),
  },

  {
    path: "/transactions/currency-settlement/form/:control_number",
    name: "EditCurrencySettlement",
    meta: { title: "Edit Currency Settlement", authRequired: true },
    component: () => import("../views/transactions/currency-settlement/form"),
  },

  {
    path: "/reports/currency-settlement",
    name: "ReportCurrencySettlement",
    meta: { title: "Currency Settlemen Reportt", authRequired: true },
    component: () => import("../views/transactions/currency-settlement/report"),
  },

  // CWT Monitoring 
  {
    path: "/government-compliance/cwt-monitoring",
    name: "CwtTaggingList",
    meta: { title: "CWT Monitoring", authRequired: true },
    component: () => import("../views/tax-management/cwt-monitoring/index.vue"),
  },

  {
    path: "/government-compliance/cwt-monitoring/form",
    name: "CreateCwtTagging",
    meta: { title: "Create CWT Monitoring", authRequired: true },
    component: () => import("../views/tax-management/cwt-monitoring/form"),
  },

  {
    path: "/government-compliance/cwt-monitoring/form/:batch_no",
    name: "EditCwtTagging",
    meta: { title: "Edit CWT Monitoring", authRequired: true },
    component: () => import("../views/tax-management/cwt-monitoring/form"),
  },

  // Government Compliance > Tax Filing
  {
    path: "/government-compliance/tax-filing/calendar",
    name: "TaxFilingCalendar",
    meta: { title: "Tax Filing Calendar", authRequired: true },
    component: () => import("../views/tax-filing/calendar.vue"),
  },
  {
    path: "/government-compliance/tax-filing/monthly",
    name: "TaxFilingMonthly",
    meta: { title: "Monthly Tax Obligations", authRequired: true },
    component: () => import("../views/tax-filing/monthly.vue"),
  },
  {
    path: "/government-compliance/tax-filing/quarterly",
    name: "TaxFilingQuarterly",
    meta: { title: "Quarterly Tax Obligations", authRequired: true },
    component: () => import("../views/tax-filing/quarterly.vue"),
  },
  {
    path: "/government-compliance/tax-filing/annual",
    name: "TaxFilingAnnual",
    meta: { title: "Annual Tax Obligations", authRequired: true },
    component: () => import("../views/tax-filing/annual.vue"),
  },
  {
    path: "/government-compliance/tax-filing/guide/:formId?",
    name: "TaxFilingGuide",
    meta: { title: "Tax Filing Guide", authRequired: true },
    component: () => import("../views/tax-filing/guide.vue"),
  },

  // Development - Helper Generator
  {
    path: "/development/generate_helper",
    name: "GenerateHelper",
    meta: { title: "Helper Generator", authRequired: true },
    component: () => import("../views/development/generate_helper/index.vue"),
  },
  {
    path: "/development/report_templates",
    name: "ReportTemplateBuilders",
    meta: { title: "Saved Report Templates", authRequired: true },
    component: () => import("../views/development/report_templates/index.vue"),
  },
  {
    path: "/development/report-template-builder",
    name: "ReportTemplateBuilderView",
    meta: { title: "Report Template Builder", authRequired: true },
    component: () => import("../views/development/report_templates/index.vue"),
  },
];